/**
 * Undo Slice
 *
 * State and actions for storing and managing undo operations.
 */

import type { StateCreator } from 'zustand';
import type { AppStore, UndoSlice } from '../types';

const MAX_UNDO_ACTIONS = 50;

export const createUndoSlice: StateCreator<AppStore, [], [], UndoSlice> = (set, get) => ({
  undoActions: [],

  storeUndoAction: (type, data) => {
    const id = `undo-${Date.now()}-${Math.random()}`;
    const timestamp = Date.now();
    const newAction = { id, type, data, timestamp };

    set((state) => ({
      undoActions: [...state.undoActions, newAction].slice(-MAX_UNDO_ACTIONS),
    }));

    return id;
  },

  clearUndoAction: (id) => {
    set((state) => ({
      undoActions: state.undoActions.filter((action) => action.id !== id),
    }));
  },

  getUndoAction: (id) => {
    const state = get();
    return state.undoActions.find((action) => action.id === id) || null;
  },
});
